/**
 * @generated SignedSource<<326d8289faa24234d7cb233516d0133b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountBillingInfoCreateInput = {
  cardBrand?: string | null;
  cardLastFour?: string | null;
  cardCountryId?: string | null;
  billingAddressLineOne?: string | null;
  billingAddressLineTwo?: string | null;
  billingCity?: string | null;
  billingState?: string | null;
  billingCountryId?: string | null;
  billingZip?: string | null;
  extraBillingInformation?: string | null;
  stripePaymentMethodRef?: string | null;
  default?: any | null;
  cardExpMonth?: number | null;
  cardExpYear?: number | null;
  accountId: string;
};
export type accountBillingInfoCreateMutation$variables = {
  input: AccountBillingInfoCreateInput;
};
export type accountBillingInfoCreateMutation$data = {
  readonly createAccountBillingInfo: {
    readonly accountBillingInfo: {
      readonly " $fragmentSpreads": FragmentRefs<"accountBillingInfoBaseFragment" | "accountBillingInfoCardFragment" | "accountBillingInfoAddressFragment">;
    };
  };
};
export type accountBillingInfoCreateMutation = {
  variables: accountBillingInfoCreateMutation$variables;
  response: accountBillingInfoCreateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "accountBillingInfoCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountBillingInfoPayload",
        "kind": "LinkedField",
        "name": "createAccountBillingInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountBillingInfo",
            "kind": "LinkedField",
            "name": "accountBillingInfo",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "accountBillingInfoBaseFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "accountBillingInfoCardFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "accountBillingInfoAddressFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "accountBillingInfoCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountBillingInfoPayload",
        "kind": "LinkedField",
        "name": "createAccountBillingInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountBillingInfo",
            "kind": "LinkedField",
            "name": "accountBillingInfo",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "extraBillingInformation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cardBrand",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cardLastFour",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cardCountryId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingAddressLineOne",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingAddressLineTwo",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingCity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingState",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingCountryId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billingZip",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Country",
                "kind": "LinkedField",
                "name": "billingCountry",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isoCodeTwo",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isoCodeThree",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "continentName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currencySymbol",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2d80ac64b4a8649a587447f6cf36afd7",
    "id": null,
    "metadata": {},
    "name": "accountBillingInfoCreateMutation",
    "operationKind": "mutation",
    "text": "mutation accountBillingInfoCreateMutation(\n  $input: AccountBillingInfoCreateInput!\n) {\n  createAccountBillingInfo(input: $input) {\n    accountBillingInfo {\n      ...accountBillingInfoBaseFragment\n      ...accountBillingInfoCardFragment\n      ...accountBillingInfoAddressFragment\n      id\n    }\n  }\n}\n\nfragment accountBillingInfoAddressFragment on AccountBillingInfo {\n  billingAddressLineOne\n  billingAddressLineTwo\n  billingCity\n  billingState\n  billingCountryId\n  billingZip\n  billingCountry {\n    ...countryFragment\n    id\n  }\n}\n\nfragment accountBillingInfoBaseFragment on AccountBillingInfo {\n  id\n  extraBillingInformation\n}\n\nfragment accountBillingInfoCardFragment on AccountBillingInfo {\n  cardBrand\n  cardLastFour\n  cardCountryId\n}\n\nfragment countryFragment on Country {\n  name\n  isoCodeTwo\n  isoCodeThree\n  continentName\n  currency\n  currencySymbol\n}\n"
  }
};
})();

(node as any).hash = "047c144010850038c552e8b25d30baa5";

export default node;
